import { PaginationInput, PaginationOutput } from 'kl-b2c-ui-kit';
import { HttpResponse, IApiService, IMediaTagsApi, Tag } from 'types';

export class MediaTagsApi implements IMediaTagsApi {
    constructor(private readonly apiService: IApiService) {}

    public get(
        params: PaginationInput & { withMedias: boolean; withHomePage?: boolean }
    ): Promise<HttpResponse<PaginationOutput<Tag>>> {
        return this.apiService.request<PaginationOutput<Tag>>({
            method: 'GET',
            url: '/MediaTag/Get',
            params,
        });
    }
}
